import { Fragment } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import Button from 'atoms/button';
import { Divider } from 'atoms/divider';
import { closeDrawer } from 'store/reducers/ui';
import { isNotEmptyArray, prettifyDate } from 'util';

export default function PastAppointments({ pastAppointments, auid }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  if (!isNotEmptyArray(pastAppointments)) return null;

  const last3Appointments = pastAppointments.slice(0, 3);
  const hasMoreAppointments = pastAppointments.length > 3;

  return (
    <div className="past-appointments-panel flex-column mb-12 p-24 border-light-purple radius-24">
      <h4>Past appointments</h4>
      {last3Appointments.map((appointment, index) => (
        <Fragment key={appointment.uuid}>
          <div className="flex-column mt-16">
            <div className="flex-row justify-between">
              <p className="f12 bold">{appointment.service?.name}</p>
              <p className="f12 bold">
                {appointment.summary?.total?.localized
                  ? appointment.summary?.total?.localized
                  : ''}
              </p>
            </div>
            <p className="f12">{prettifyDate(appointment.dateStart)}</p>
            <p className="f12 italic past-appointment-note">
              {appointment.note}
            </p>
          </div>
          {index === last3Appointments.length - 1 &&
          !hasMoreAppointments ? null : (
            <Divider className="mt-16" />
          )}
        </Fragment>
      ))}
      {hasMoreAppointments && (
        <Button
          text="View all"
          onClick={() => {
            navigate(`/pet-profile/${auid}`);
            dispatch(closeDrawer());
          }}
          variant="link"
          size="small"
          className="mt-16"
        />
      )}
    </div>
  );
}
